import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

export const TagsFiltersBar: FC<{
  loading: boolean
  query: string
  onQuery: (v: string) => void
  category: string
  onCategory: (v: string) => void
  categories: string[]
  onRefresh: () => void
  onCreate: () => void
}> = ({ loading, query, onQuery, category, onCategory, categories, onRefresh, onCreate }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:flex-wrap">
      <div className="flex flex-col gap-2 md:flex-row md:items-center">
        <input
          className={clsx(
            "input input-bordered w-full md:w-[320px]",
            "bg-white dark:bg-[#0C0C1A]",
            "text-black dark:text-white",
            "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
          )}
          placeholder={t("tags.searchByNameSlug")}
          value={query}
          onChange={(e) => onQuery(e.target.value)}
        />

        <select
          className={clsx(
            "select select-bordered w-full md:w-[220px]",
            "bg-white dark:bg-[#0C0C1A]",
            "text-black dark:text-white",
            "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
          )}
          value={category}
          onChange={(e) => onCategory(e.target.value)}
        >
          <option value="">{t("tags.allCategories")}</option>
          {categories.map((c) => (
            <option value={c} key={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      <div className="flex gap-2">
        <button className={clsx("btn btn-sm", { "btn-disabled": loading })} onClick={onRefresh}>
          {t("common.refresh")}
        </button>
        <button className="btn btn-sm btn-primary" onClick={onCreate}>
          {t("tags.newManualTag")}
        </button>
      </div>
    </div>
  )
}
